import script from "./ContactFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactFilters.vue?vue&type=script&setup=true&lang=js"

import "./ContactFilters.vue?vue&type=style&index=0&id=396811b9&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-396811b9"]])

export default __exports__